export const LIGHT_DESIRE_MAX = 0.45;
